/**
 * Determine if running in NodeJS
 */
export const inNodeJS = (typeof process !== 'undefined') && (process?.release?.name === 'node')
export const isNodeJS = inNodeJS

/**
 * Determine if running in the browser
 */
export const inBrowser = (typeof window !== 'undefined')
export const isBrowser = inBrowser
